import AnalyticsDashboardAppConfig from './analytics/AnalyticsDashboardAppConfig';
import ProjectDashboardAppConfig from './project/ProjectDashboardAppConfig';
import FinanceDashboardAppConfig from './finance/FinanceDashboardAppConfig';
import CryptoDashboardAppConfig from './crypto/CryptoDashboardAppConfig';

const dashboardsConfigs = [
  AnalyticsDashboardAppConfig,
  ProjectDashboardAppConfig,
  FinanceDashboardAppConfig,
  CryptoDashboardAppConfig,
];

export default dashboardsConfigs;
